import React from 'react';

import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';

import styles from './ideaInformationStyles.scss';

const IdeaInformationLoading: React.FC = () => {
  return (
    <InfoTable title="Idea Information">
      {({ labelStyle, dataStyle }): React.ReactElement => {
        return (
          <table className={styles.ideaTable}>
            <tbody>
              <tr>
                <td className={labelStyle}>Situation</td>
                <td className={dataStyle}>
                  <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
                </td>
              </tr>
              <tr>
                <td className={labelStyle}>Target Allocation</td>
                <td className={dataStyle}>
                  <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
                </td>
              </tr>
              <tr>
                <td className={labelStyle}>Time Frame</td>
                <td className={dataStyle}>
                  <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
                </td>
              </tr>
              <tr>
                <td className={labelStyle}>Catalysts</td>
                <td className={dataStyle}>
                  <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
                </td>
              </tr>
            </tbody>
          </table>
        );
      }}
    </InfoTable>
  );
};

export default IdeaInformationLoading;
